<template>
  <div class="container">
    <div class="row justify-content-center min-vh-100 align-items-center">
      <div class="col-12 col-sm-8 col-md-5 col-lg-4">
        <div class="card shadow-sm">
          <div class="card-body p-4">
            <h3 class="text-center mb-4">Serverless Invoices</h3>

            <div v-if="error" class="alert alert-danger">{{ error }}</div>

            <form @submit.prevent="submit">
              <div class="form-group">
                <label for="username">Username</label>
                <input
                  id="username"
                  v-model="username"
                  type="text"
                  class="form-control"
                  placeholder="Enter username"
                  required
                  autofocus
                />
              </div>

              <div class="form-group">
                <label for="password">Password</label>
                <input
                  id="password"
                  v-model="password"
                  type="password"
                  class="form-control"
                  placeholder="Enter password"
                  required
                />
              </div>

              <button type="submit" class="btn btn-primary btn-block" :disabled="loading">
                {{ loading ? 'Please wait...' : (isRegister ? 'Register' : 'Login') }}
              </button>
            </form>

            <p class="text-center mt-3 mb-0">
              <a href="#" @click.prevent="isRegister = !isRegister">
                {{ isRegister ? 'Already have an account? Login' : 'No account? Register' }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/auth.service';

export default {
  data() {
    return {
      username: '',
      password: '',
      isRegister: false,
      loading: false,
      error: null,
    };
  },
  methods: {
    async submit() {
      this.error = null;
      this.loading = true;

      try {
        if (this.isRegister) {
          await AuthService.register(this.username, this.password);
        } else {
          await AuthService.login(this.username, this.password);
        }
        this.$router.push('/');
      } catch (err) {
        this.error = (err.response && err.response.data && err.response.data.error) || 'Something went wrong';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
